import {action, Action} from 'easy-peasy';

interface QualityAssuranceDataItem {
    date: string;
    total: number;
    no_lang: number;
    no_anon: number;
    calls_fully_processed?: number;
    emails_fully_processed?: number;
    feedbacks_fully_processed?: number;
    chats_fully_processed?: number;
}

export interface QualityAssuranceDataStoreModel {
    items: QualityAssuranceDataItem[];
    loadQualityAssuranceData: Action<QualityAssuranceDataStoreModel, QualityAssuranceDataItem[]>;
    loading: boolean;
    setLoading: Action<QualityAssuranceDataStoreModel, boolean>;
}

export default <QualityAssuranceDataStoreModel>{
    items: [],
    loadQualityAssuranceData: action((state, qualityAssuranceDataList) => {
        state.items = qualityAssuranceDataList;
    }),
    loading: false,
    setLoading: action((state, loading) => {
        state.loading = loading;
    }),
}; 